import { render, staticRenderFns } from "./SiteCreate.vue?vue&type=template&id=6218b23f&scoped=true&"
import script from "./SiteCreate.vue?vue&type=script&lang=js&"
export * from "./SiteCreate.vue?vue&type=script&lang=js&"
import style0 from "./SiteCreate.vue?vue&type=style&index=0&id=6218b23f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6218b23f",
  null
  
)

export default component.exports